import { Action, Dispatch } from 'redux';
import { get } from 'components/Shared/server';
import { ConservatorySizeProductModel } from 'models/ConservatorySizeProductModel';

const RESPONSESTATUS_SUCCESS = 200;

export const GUIDE_SIZE_DATA_LOADING = 'GUIDE_SIZE_DATA_LOADING';
export const GUIDE_SIZE_DATA_LOADED = 'GUIDE_SIZE_DATA_LOADED';
export const GUIDE_SIZE_VALID = 'GUIDE_SIZE_VALID';
export const GUIDE_SIZE_INVALID = 'GUIDE_SIZE_INVALID';
export const GUIDE_SIZE_TOGGLE_CORNERS = 'GUIDE_SIZE_TOGGLE_CORNERS';
export const GUIDE_SIZE_SELECT_WIDTH = 'GUIDE_SIZE_SELECT_WIDTH';
export const GUIDE_SIZE_SELECT_DEPTH = 'GUIDE_SIZE_SELECT_DEPTH';

export interface GuideSizeAction extends Action {
  products: ConservatorySizeProductModel[];
}

export interface GuideSizeSelectAction extends Action {
  size: number;
}

export interface GuideSizeCornerAction extends Action {
  cornerLeft: boolean;
  cornerRight: boolean;
}

export const guideSizeValid = () => ({
  type: GUIDE_SIZE_VALID
});

export const guideSizeInValid = () => ({
  type: GUIDE_SIZE_INVALID
});

export const guideSizeToggleCorners = (cornerLeft: boolean, cornerRight: boolean) => ({
  type: GUIDE_SIZE_TOGGLE_CORNERS,
  cornerLeft,
  cornerRight
});

export const guideSizeSelectWidth = (size: number) => ({
  type: GUIDE_SIZE_SELECT_WIDTH,
  size
});

export const guideSizeSelectDepth = (size: number) => ({
  type: GUIDE_SIZE_SELECT_DEPTH,
  size
});

export const guideSizeDataloaded = (sizeProducts?: ConservatorySizeProductModel[] | undefined) => ({
  type: GUIDE_SIZE_DATA_LOADED,
  products: sizeProducts
});

export const guideSizeDataloading = () => ({
  type: GUIDE_SIZE_DATA_LOADING,
  products: undefined
});

export const guideSizeFetchData = (productId: string) => {
  return (dispatch: Dispatch) => {
    dispatch(guideSizeDataloading());

    if (productId.length < 1) {
      dispatch(guideSizeDataloaded(undefined));
      return;
    }

    void get({ url: '/conservatory/getsizedata?productId=' + productId })
      .then(response => {
        if (response.status !== RESPONSESTATUS_SUCCESS) {
          dispatch(guideSizeDataloaded(undefined));
          return;
        }

        return response.json();
      })
      .then((data: ConservatorySizeProductModel[]) => {
        dispatch(guideSizeDataloaded(data));
      });
  };
};
